import React from 'react';
import IconArrowRight from 'components/IconArrowRight';
import Line from 'components/Line';
import NextSteps from 'components/NextSteps';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import SalesCalloutInspiration from 'components/SalesCalloutInspiration';
import Layout3x1 from 'components/Layout3x1';
import { withPageStaticProps } from 'utils/header';

interface Props {
  url: string;
  imgUrl: string;
  imgAlt: string;
  excerpt: string;
  citation: string;
  trackerClass: string;
  title: string;
}

const LinkPanel = ({ url, imgUrl, imgAlt, excerpt, citation, trackerClass, title }: Props) => {
  return (
    <div className="flex flex-1 flex-col pb-32 sm:pb-0">
      <a
        mb={4}
        className={`
          ${trackerClass}
        mb-0
          flex
          flex-1
          flex-col
          bg-white
          transition
          duration-200
          hover:no-underline
          hover:shadow-3
        `}
        href={url}
        target="_blank"
      >
        <div className="aspect-ratio-1by1">
          <img src={imgUrl} alt={imgAlt} />
        </div>
        <div className="p-16">
          <p className="text-h5 mb-8 text-sm text-gray">{citation}</p>
          <h2 className="text-h4 mb-8">{title}</h2>
          <h3 className="mb-16 text-base font-normal text-gray-darker">{excerpt}</h3>
          <p className="inline-flex items-center text-gold-darker">
            Read More <IconArrowRight className="ml-4 !text-gold-darker" />
          </p>
        </div>
      </a>
    </div>
  );
};

interface NewsItem {
  id: number;
  imgSrc: string;
  imgAlt: string;
  title: string;
  content: string;
  linkUrl: string;
}

const newsItemsList: NewsItem[] = [
  {
    id: 1,
    imgSrc: 'https://gentux.imgix.net/1639590328_BridesofNorthTexas20211215114500.jpg',
    imgAlt: 'Brides of North Texas',
    title: 'A Classy Chic Texas Mansion Wedding',
    content: 'Hayden and Logan were married in a classic and chic Texas mansion wedding at The Milestone | Aubrey. See their photos here!',
    linkUrl: 'https://www.bridesofnorthtexas.com/article/texas-mansion-wedding/',
  },
  {
    id: 2,
    imgSrc: 'https://gentux.imgix.net/1639590176_WeddingsInHoustonbadge20211215114000.png',
    imgAlt: 'Weddings In Houston',
    title: 'OU Sooners Have A Blush and Burgundy Wedding at The Carriage House',
    content:
      'Newlyweds had a blush and burgundy wedding in April at a rustic venue in Montgomery, TX. Read more about Matthew and Lauren\u0027s love story!',
    linkUrl: 'https://www.weddingsinhouston.com/blog/ou-sooners-have-a-blush-and-burgundy-wedding-at-the-carriage-house/',
  },
  {
    id: 3,
    imgSrc: 'https://gentux.imgix.net/1639589359_Insiderbadge202011215112800.png',
    imgAlt: 'Insider',
    title: 'A Couple Kept Their Engagement A Secret For 9 Months And Had A Surprise Wedding',
    content:
      'Amy and Ryan Nolan planned a surprise wedding, inviting their guests, who didn\u0027t even know they were engaged, to a nonexistent birthday party.',
    linkUrl: 'https://www.insider.com/couple-had-secret-engagement-for-9-months-surprise-wedding-photos-2021-10',
  },
  {
    id: 4,
    imgSrc: 'https://gentux.imgix.net/1639589583_BrideandBlossombadge20211215113100.jpg',
    imgAlt: 'Bride and Blossom',
    title: 'Joye & Scott Say “I Do” In A Breathtakingly Chic Sky-High Ceremony',
    content:
      'This week, BB Featured Bride Joye reminisces on her breathtaking sky-high ceremony at Tribeca Rooftop. “We’ve been to so many weddings, but never one on a Manhattan rooftop. After taking in the views, we couldn’t see us getting married without the NYC skyline in the background.”',
    linkUrl: 'https://www.brideandblossom.com/blog/joye-scott-say-i-do-in-a-breathtakingly-chic-sky-high-ceremony/',
  },
  {
    id: 5,
    imgSrc: 'https://gentux.imgix.net/1571239745_Martha-Stewart-Weddings-Feature-Badge-1.png',
    imgAlt: 'Martha Stewart Weddings',
    title: 'This Couple Downsized Their Colorado Wedding\u0027s Guest List to Ensure That the Bride\u0027s Dad Could Attend',
    content: 'Go inside this romantic micro wedding in Colorado, which was attended by just 10 guests.',
    linkUrl: 'https://www.marthastewart.com/8018366/colorado-micro-wedding-amanda-berube',
  },
  {
    id: 6,
    imgSrc: 'https://gentux.imgix.net/1639590498_APrqacticalWeddingbadge20211215114000.png',
    imgAlt: 'People',
    title: 'See Every Photo from Brant Daugherty and Kim Hidalgo\u0027s Romantic California Wedding',
    content:
      'After meeting more than three years ago, Pretty Little Liars star Brant Daugherty weds actress Kim Hidalgo in a sweet California celebration',
    linkUrl:
      'https://people.com/tv/brant-daugherty-kim-hidalgo-wedding-photos/?fbclid=IwAR3sh9xoTFwRrpNAzypsWIbYsJGyWx0uYAPP99m42EXdTbEAfy-Dkvm6mmk&slide=7117395#7117395',
  },
  {
    id: 7,
    imgSrc: 'https://gentux.imgix.net/in-the-news-stylemepretty.jpg',
    imgAlt: 'Style Me Pretty',
    title: 'Modern Elegant California Wedding Inspiration at Rancho Bella Vista',
    content:
      'Jenny Quicksall and the entire vendor team came together to craft a collection of inspirational moments that will set your heart aflutter.',
    linkUrl: 'https://www.stylemepretty.com/2019/05/03/modern-elegant-california-wedding-inspiration-at-rancho-bella-vista/',
  },
  {
    id: 8,
    imgSrc: 'https://gentux.imgix.net/in-the-news-apracticalwedding.jpg',
    imgAlt: 'A Practical Wedding',
    title: 'A Suit Skeptic Tries Out Online Tux Rentals',
    content:
      'A Preactical Weedding put Generation Tux\u0027s online suit and tux service to test with our pickiest client: our founder and CEO\u0027s husband. This was his experience.',
    linkUrl: 'https://apracticalwedding.com/generation-tux-review/',
  },
  {
    id: 9,
    imgSrc: 'https://gentux.imgix.net/1571239745_Martha-Stewart-Weddings-Feature-Badge-1.png',
    imgAlt: 'Martha Stewart Weddings',
    title: 'wedding planning tasks you can complete from your couch',
    content:
      'As any bride- or groom-to-be can tell you, planning a wedding means you\u0027ll spend most weekends crossing items off your to-do list. Here\u0027s a list of the easiest things you can do from the comfort of your couch.',
    linkUrl: 'https://www.marthastewartweddings.com/659520/wedding-planning-tasks-can-complete-from-couch',
  },
  {
    id: 10,
    imgSrc: 'https://gentux.imgix.net/1571239743_Couture%20Colorado.png',
    imgAlt: 'Couture Colorado',
    title: 'wild and free morrison styled shoot',
    content:
      'This Wild and Free wedding styled shoot features vintage details, colorful florals, and a modern white barn. The perfect summer wedding! Also featuring Generation Tux\u0027s Mystic Blue Notch Lapel Tuxedo. ',
    linkUrl: 'https://www.couturecolorado.com/blog/wild-and-free-morrison-styled-shoot/',
  },
  {
    id: 11,
    imgSrc: 'https://gentux.imgix.net/1571252713_Tacari-Weddings-logo.png',
    imgAlt: 'Tacari Weddings',
    title: 'zach and matt',
    content:
      'This brightly colored styled shoot is complete with an elegant black and white styling and a touch of pink to pop to celebrate spring. Featuring Generation Tux\u0027s Black Shawl Lapel Tuxedo and White Shawl Lapel Tuxedo.',
    linkUrl: 'https://tacariweddings.com/styled-shoot-zach-and-matt/',
  },
  {
    id: 12,
    imgSrc: 'https://gentux.imgix.net/1571239747_Southern_California_Bride_FEAUTRED_Badges_05-copy.png',
    imgAlt: 'The Southern California Bride',
    title: 'citrus wedding ideas at the condor nest ranch',
    content:
      'The bold palette of this styled shoot plays off the colors of the vintage umbrellas and tables by the aqua pool. The neutral gown adds a touch of romance and femininity, while the black tux seamlessly pulls the look together making it classic and timeless.',
    linkUrl: 'http://www.thesoutherncaliforniabride.com/2019/07/citrus-wedding-ideas-at-condor-nest-ranch.html',
  },
  {
    id: 13,
    imgSrc: 'https://gentux.imgix.net/1571239743_brides-badge.png',
    imgAlt: 'Brides',
    title: '12 neon wedding signs to brighten up your reception',
    content:
      'Who doesn\u0027t love a good neon sign? These are sure to shine during your wedding reception. Featuring Generation Tux\u0027s Black Peak Lapel Tuxedo.',
    linkUrl: 'https://www.brides.com/gallery/neon-wedding-signs-to-brighten-your-wedding-reception',
  },
  {
    id: 14,
    imgSrc: 'https://gentux.imgix.net/in-the-news-wedchick.jpg',
    imgAlt: 'Wedding Chicks',
    title: 'how to make your first look the best moment of the day',
    content:
      'Your day will be a complete whirlwind, full of excitement, nerves, disbelief, enchantment, all of it, and you\u0027ll barely have a minute to yourselves. Which is why a first look is so important. Featuring Generation Tux\u0027s Charcoal Notch Lapel Suit.',
    linkUrl: 'https://www.weddingchicks.com/blog/how-to-make-your-first-look-the-best-moment-of-the-day-l-17698-l-41.html',
  },
  {
    id: 15,
    imgSrc: 'https://gentux.imgix.net/1571239744_DID.jpeg',
    imgAlt: 'Destination I Do',
    title: 'a winter wedding in maui',
    content:
      'This inspired destination wedding combines the natural beauty of Maui with a classic wedding vibe. Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://destinationido.com/winter-wedding-in-maui',
  },
  {
    id: 16,
    imgSrc: 'https://gentux.imgix.net/1571239744_every%20last%20detail.png',
    imgAlt: 'The Every Last Detail',
    title: 'organic pink and navy wedding ideas',
    content:
      'Boasting a romantic, organic style, these pink and navy wedding ideas are everything! This styled shoot features classic blush details, but throw in some brighter shades for a touch of modern elegance. Also featuring Generation Tux\u0027s Cement Gray Notch Lapel Suit.',
    linkUrl: 'https://theeverylastdetail.com/organic-pink-and-navy-wedding-ideas/',
  },
  {
    id: 17,
    imgSrc: 'https://gentux.imgix.net/1571239744_DID.jpeg',
    imgAlt: 'Destination I Do',
    title: 'tips on how to propose',
    content:
      'Deciding to propose is a huge step for any guy. Everything has to be just right and these tips can help out. Featuring Generation Tux\u0027s Black Notch Lapel Tuxedo and Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://destinationido.com/tips-on-how-to-propose',
  },
  {
    id: 18,
    imgSrc: 'https://gentux.imgix.net/1571240519_Featured-on-California-Wedding-Day.png',
    imgAlt: 'California Wedding Day',
    title: 'around the globe beautiful travel inspired wedding at the historic darlington house in la jolla',
    content:
      'This travel-themed La Jolla wedding features a romantic, garden vision with big, soft white florals, greens, and a slightly rustic theme. Also featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://californiaweddingday.com/around-globe-beautiful-travel-inspired-wedding-historic-darlington-house-la-jolla',
  },
  {
    id: 19,
    imgSrc: 'https://gentux.imgix.net/in-the-news-loverly.jpg',
    imgAlt: 'Loverly',
    title: 'something blue wedding inspiration you need to see!',
    content:
      'If you\u0027ve ever wondered how to incorporate your \u0022something blue\u0022 into your wedding day, this is the wedding inspiration for you! From the floral arrangements to the desserts to the table settings, this day is dripping in our favorite dreamy shade of blue! Featuring Generation Tux\u0027s Black Notch Lapel Tuxedo.',
    linkUrl: 'https://lover.ly/planning/news-tips/something-blue-wedding-inspiration/',
  },
  {
    id: 20,
    imgSrc: 'https://gentux.imgix.net/1571239744_Green-Wedding-Shoes-Feature-Badge.png',
    imgAlt: 'Green Wedding Shoes',
    title: '10 sneaky ways to cut your wedding budget',
    content:
      'Save vs. splurge vs. save again. It\u0027s a balance, wedding planning, and we\u0027re all for saving money where you can! Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://greenweddingshoes.com/10-sneaky-ways-to-cut-your-wedding-budget/',
  },
  {
    id: 21,
    imgSrc: 'https://gentux.imgix.net/1571239747_United%20With%20Love.png',
    imgAlt: 'United With Love',
    title: 'modern meets traditional wedding inspiration',
    content:
      'Drawing inspiration from Southern charm and grace, this styled shoot has design elements that resonated with the couple and items that they would have held near and dear, having been handed down through the generations. Featuring Generation Tux\u0027s Black Shawl Lapel Tuxedo.',
    linkUrl: 'https://unitedwithlove.com/2019/06/14/modern-meets-traditional-wedding-inspiration/',
  },
  {
    id: 22,
    imgSrc: 'https://gentux.imgix.net/1571239745_inside-wedding.jpg',
    imgAlt: 'Inside Weddings',
    title: 'chic winter wedding at a church + industrial, artsy venue in denver',
    content:
      'This lovely Denver wedding was styled after the bride\u0027s wish for the event to look and feel extremely romantic. She built her vision around deep reds, mossy greens, and candles. Featuring Generation Tux\u0027s Black Peak Lapel Tuxedo.',
    linkUrl: 'https://www.insideweddings.com/weddings/chic-winter-wedding-at-a-church-industrial-artsy-venue-in-denver/1289/',
  },
  {
    id: 23,
    imgSrc: 'https://gentux.imgix.net/1571239746_ps-dot-logo.png',
    imgAlt: 'Popsugar',
    title: 'roses are red, belle wears blue, this beauty and the beast wedding is a dream come true',
    content:
      'This Beauty and the Beast themed wedding is really a tale as old as time. Featuring Generation Tux\u0027s Charcoal Notch Lapel Suit.',
    linkUrl: 'https://www.popsugar.com/love/Beauty-Beast-Inspired-Wedding-46091578?stream_view=1#photo-46091618',
  },
  {
    id: 24,
    imgSrc: 'https://gentux.imgix.net/1571239742_betches.svg',
    imgAlt: 'Betches',
    title: '9 ways to cut wedding costs',
    content:
      'Weddings are expensive. They\u0027re also one of the most important days of your life, and you don\u0027t want to skimp on the details! Here are a few ways to save money without sacrificing your aesthetic.',
    linkUrl: 'https://betches.com/9-ways-to-cut-wedding-costs/',
  },
  {
    id: 25,
    imgSrc: 'https://gentux.imgix.net/in-the-news-loverly.jpg',
    imgAlt: 'Loverly',
    title: 'unforgettable rustic details from this colorado ranch wedding',
    content:
      'The little details in this romantic ranch wedding, like the rustic decor on the ceremony arch and the boots the bride wore, brought everything together for this outdoor wedding vision. Featuring Generation Tux\u0027s Gray Sharkskin Notch Lapel Suit.',
    linkUrl: 'https://lover.ly/planning/news-tips/colorado-ranch-wedding/',
  },
  {
    id: 26,
    imgSrc: 'https://gentux.imgix.net/1571239744_DID.jpeg',
    imgAlt: 'Destination I Do',
    title: 'dest weds: 10 things couples forget',
    content:
      'Considering or hosting a destination wedding can prompt a lot of questions. Like with any wedding, you and your partner will want to address these questions and explore all your options to make the most informed decisions possible.',
    linkUrl: 'https://destinationido.com/destination-weddings-10-things-couples-forget',
  },
  {
    id: 27,
    imgSrc: 'https://gentux.imgix.net/1571239744_Green-Wedding-Shoes-Feature-Badge.png',
    imgAlt: 'Green Wedding Shoes',
    title: '10 wedding planning tasks you can check off without leaving the couch',
    content:
      'We\u0027re always looking for ways to make wedding planning easier. It\u0027s an endless journey, for sure, but thankfully we have a few things you can knock off your list from your couch. Featuring Generation Tux\u0027s Black Peak Lapel Tuxedo.',
    linkUrl: 'https://greenweddingshoes.com/10-wedding-planning-tasks-you-can-check-off-without-leaving-the-couch/',
  },
  {
    id: 28,
    imgSrc: 'https://gentux.imgix.net/1571239744_DID.jpeg',
    imgAlt: 'Destination I Do',
    title: 'spring bouquet inspiration',
    content:
      'We\u0027re sharing some inspirational spring bouquets to get your floral juices flowing. Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://destinationido.com/spring-bouquet-inspiration',
  },
  {
    id: 29,
    imgSrc: 'https://gentux.imgix.net/1571239743_boho%20weddings.png',
    imgAlt: 'Boho Weddings',
    title: 'lauren and nathan\u0027s ethereal flower filled conservatory wedding by northern native photography',
    content:
      'The whole conservatory wedding was full of flowers and was like something out of a film. Featuring Generation Tux\u0027s Black Shawl Lapel Tuxedo and Charcoal Notch Lapel Tuxedo.',
    linkUrl: 'https://www.boho-weddings.com/2019/05/20/ethereal-flower-filled-conservatory-wedding-by-northern-native-photography/',
  },
  {
    id: 30,
    imgSrc: 'https://gentux.imgix.net/1571242395_yahoo-logo',
    imgAlt: 'Yahoo',
    title: 'the 6 most efficient wedding planning sites for the bride on-the-go',
    content:
      'Now that you\u0027re engaged, it\u0027s time to put some thought into the most efficient way to plan your dream wedding. The good news is that there are websites that make wedding planning oh-so-smooth, even if you\u0027re always on the go. Featuring Generation Tux\u0027s Navy Blue Notch Lapel Suit.',
    linkUrl: 'https://www.yahoo.com/lifestyle/6-most-efficient-wedding-planning-142031453.html',
  },
  {
    id: 31,
    imgSrc: 'https://gentux.imgix.net/1571239743_BritCo-logo.png',
    imgAlt: 'Brit + Co',
    title: 'the 6 most efficient wedding planning sites for the bride on-the-go',
    content:
      'Now that you\u0027re engaged, it\u0027s time to put some thought into the most efficient way to plan your dream wedding. The good news is that there are websites that make wedding planning oh-so-smooth, even if you\u0027re always on the go. Featuring Generation Tux\u0027s Navy Blue Notch Lapel Suit.',
    linkUrl: 'https://www.brit.co/digital-tools-for-brides/',
  },
  {
    id: 32,
    imgSrc: 'https://gentux.imgix.net/1571239747_RMB.png',
    imgAlt: 'Rocky Mountain Bride',
    title: 'summer wedding moss denver',
    content:
      'This summer wedding in Denver included so many laughs and smiles during their ceremony both from the couple and their guests. Featuring Generation Tux\u0027s Navy Blue Notch Lapel Suit.',
    linkUrl: 'https://www.rockymountainbride.com/blog/summer-wedding-moss-denver/',
  },
  {
    id: 33,
    imgSrc: 'https://gentux.imgix.net/1571239742_betches.svg',
    imgAlt: 'Betches',
    title: '8 wedding websites that will make planning so much less stress',
    content:
      'Now you have to keep the same energy you put into getting engaged into actually planning the wedding. Here are a few websites to help with that. ',
    linkUrl: 'https://betches.com/8-wedding-websites-that-will-make-planning-so-much-less-stressful/',
  },
  {
    id: 34,
    imgSrc: 'https://gentux.imgix.net/1571239746_ps-dot-logo.png',
    imgAlt: 'Popsugar',
    title: 'if you are saying \u0022i do\u0022 this spring, these wedding bouquets are for you',
    content:
      'Bring seasonal touches into your special day with bouquets made from colorful Spring flowers and gorgeous greenery. Featuring Generation Tux\u0027s Black Peak Lapel Tuxedo and Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://www.popsugar.com/love/Spring-Wedding-Bouquets-45888881?stream_view=1#photo-45889770',
  },
  {
    id: 35,
    imgSrc: 'https://gentux.imgix.net/1571239742_bm-badge-white.jpg',
    imgAlt: 'Bridal Musings',
    title: 'tropical maui luau wedding',
    content:
      'This Maui wedding encompasses so much of what we love about destination weddings, thanks to a jet-set couple ready to embrace the local Hawaiian culture. Featuring Generation Tux\u0027s Bright Blue Notch Lapel Suit.',
    linkUrl: 'https://bridalmusings.com/150783/tropical-maui-luau-wedding/',
  },
  {
    id: 36,
    imgSrc: 'https://gentux.imgix.net/1571239742_Belle_badge-ID-c7523ffa-a5ec-4017-f2a5-dedf1893dde7.png',
    imgAlt: 'Belle the Magazine',
    title: 'romantic rainy day wedding moments + tips',
    content:
      'No couple hopes for rain on their wedding day, but even the most fastidious brides and grooms can\u0027t always predict the weather. We can\u0027t let a little rain ruin this special day, though! Featuring Generation Tux\u0027s Bright Blue Notch Lapel Suit.',
    linkUrl: 'https://bellethemagazine.com/2019/04/romantic-rainy-day-wedding-moments-tips.html',
  },
  {
    id: 37,
    imgSrc: 'https://gentux.imgix.net/1571239743_boho%20weddings.png',
    imgAlt: 'Boho Weddings',
    title: 'marissa and adam\u0027s rustic lush ski resort wedding by bethany small',
    content:
      'This stunning off-season ski resort wedding is complete with lots of greenery, lush white flowers and lots of rustic wood touches. Featuring Generation Tux\u0027s Bright Blue Notch Lapel Suit.',
    linkUrl: 'https://www.boho-weddings.com/2019/04/16/rustic-lush-ski-resort-wedding-by-bethany-small/',
  },
  {
    id: 38,
    imgSrc: 'https://gentux.imgix.net/in-the-news-wedchick.jpg',
    imgAlt: 'Wedding Chicks',
    title: 'a rooftop wedding in savannah to ring in the new year',
    content:
      'This timeless and chic New Year\u0027s Eve wedding was a beautiful rooftop ceremony followed by a modern indoor reception where they partied till midnight. Featuring Generation Tux\u0027s Black Notch Lapel Tuxedo.',
    linkUrl: 'https://www.weddingchicks.com/blog/a-rooftop-wedding-in-savannah-to-ring-in-the-new-year-l-17412-l-43.html',
  },
  {
    id: 39,
    imgSrc: 'https://gentux.imgix.net/1571239744_Equally-Wed-Featured-On_250x250.png',
    imgAlt: 'Equally Wed',
    title: '19 lgbtq inclusive texas wedding vendors save the day for two grooms rejected by bigoted venue',
    content:
      'Nineteen wedding vendors come together to donate their services and help throw a dream wedding for two grooms after they were rejected by a Texas venue.',
    linkUrl: 'https://equallywed.com/19-lgbtq-inclusive-texas-wedding-vendors-save-the-day-for-two-grooms-rejected-by-bigoted-venue/',
  },
  {
    id: 40,
    imgSrc: 'https://gentux.imgix.net/1571239743_ConfettiDaydreams-Wedding-Blog-250x250-1-150x1501-150x150.png',
    imgAlt: 'Confetti Daydreams',
    title: '50+ beautiful eco-friendly, zero waste + sustainable wedding ideas',
    content:
      'Planning an eco-friendly wedding that will be kind to nature and the environment? Then you\u0027re going to love these 50+ sustainable, eco-friendly and low/ zero waste wedding hacks.',
    linkUrl: 'https://www.confettidaydreams.com/eco-friendly-zero-waste-wedding-guide/',
  },
  {
    id: 41,
    imgSrc: 'https://gentux.imgix.net/1571239743_boho%20weddings.png',
    imgAlt: 'Boho Weddings',
    title: 'shana and hogan\u0027s jewel toned autumn wedding in texas by taylor sivard',
    content:
      'When it comes to Autumn styling this wedding has it all, from warm rich colors, to giant pumpkins to amazing jewel tones. Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://www.boho-weddings.com/2019/04/30/jewel-toned-autumn-wedding-in-texas-by-taylor-sivard/',
  },
  {
    id: 42,
    imgSrc: 'https://gentux.imgix.net/1571239745_IBT.png',
    imgAlt: 'Inspired By This',
    title: 'why you should embrace rain on your wedding day',
    content:
      'These rainy wedding photos will go ahead and prove that rain on your wedding day isn\u0027t the worst thing. Featuring Generation Tux\u0027s Bright Blue Notch Lapel Suit',
    linkUrl: 'http://www.inspiredbythis.com/wed/rain-on-your-wedding-day/',
  },
  {
    id: 43,
    imgSrc: 'https://gentux.imgix.net/1571239746_ps-dot-logo.png',
    imgAlt: 'Popsugar',
    title: '100+ photos that are all the inspiration you need to have a green wedding',
    content:
      'A wedding\u0027s color scheme holds high importance for a wedding theme. With green being the color of renewal, growth, and harmony, there\u0027s a reason so many brides incorporate it into their big day. Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://www.popsugar.com/love/Green-Wedding-Ideas-45825660?stream_view=1#photo-45826204',
  },
  {
    id: 44,
    imgSrc: 'https://gentux.imgix.net/in-the-news-loverly.jpg',
    imgAlt: 'Loverly',
    title: 'subtle ways to showcase lgbtq pride at your wedding',
    content:
      'We love LGBTQ wedding ideas so we turned to the experts to give their tips on small & creative ways you can showcase LGBTQ pride into your happy occasion! Featuring Generation Tux\u0027s Navy Blue Notch Lapel Suit and Charcoal Notch Lapel Suit.',
    linkUrl: 'https://lover.ly/planning/news-tips/wedding-101/subtle-ways-to-showcase-lgbtq-pride-at-your-wedding/',
  },
  {
    id: 45,
    imgSrc: 'https://gentux.imgix.net/in-the-news-loverly.jpg',
    imgAlt: 'Loverly',
    title: 'a crystal springs resort wedding every moody bride will love',
    content:
      'This moody Crystal Springs wedding has every boho-chic detail you could possibly want! Featuring Generation Tux\u0027s Mystic Blue Notch Lapel Tuxedo.',
    linkUrl: 'https://lover.ly/planning/news-tips/wedding-101/a-crystal-springs-resort-wedding-every-moody-bride-will-love/',
  },
  {
    id: 46,
    imgSrc: 'https://gentux.imgix.net/1571239744_Green-Wedding-Shoes-Feature-Badge.png',
    imgAlt: 'Green Wedding Shoes',
    title: 'step on up, grooms! the green wedding shoes x the tie bar collection is here!',
    content:
      'Green Wedding Shoes partners with the Tie Bar, pulling cool textures from Morocco, painterly swatches and abstract art, lots of lovely linens and chambray. Featuring Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://greenweddingshoes.com/green-wedding-shoes-x-the-tie-bar-collection-is-here/',
  },
  {
    id: 47,
    imgSrc: 'https://gentux.imgix.net/1571239742_Belle_badge-ID-c7523ffa-a5ec-4017-f2a5-dedf1893dde7.png',
    imgAlt: 'Belle the Magazine',
    title: 'valentine\u0027s day wedding ideas',
    content:
      'A wedding celebration is all about love, so it\u0027s no surprise that some couples want to tie the knot on the most romantic day of the Valentine\u0027s Day! Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://bellethemagazine.com/2019/02/valentines-day-wedding-ideas.html',
  },
  {
    id: 48,
    imgSrc: 'https://gentux.imgix.net/in-the-news-loverly.jpg',
    imgAlt: 'Loverly',
    title: '13 non-cheesy valentine\u0027s day wedding ideas',
    content:
      'What better way to celebrate everlasting love than with a wedding on Valentine\u0027s Day? It is really easy to have a V-Day wedding trendy to cheesy so we thought we would round up some helpful non-cheesy ideas. Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://lover.ly/planning/news-tips/how-to/13-non-cheesy-valentines-day-wedding-ideas/',
  },
  {
    id: 49,
    imgSrc: 'https://gentux.imgix.net/1571239745_Martha-Stewart-Weddings-Feature-Badge-1.png',
    imgAlt: 'Martha Stewart Weddings',
    title: 'expert-approved tips for planning a unique valentine\u0027s day proposal',
    content:
      'There\u0027s no doubt about Valentine\u0027s Day, hailed as the most romantic day of the year, is a fitting time to propose. Here, seven tips to inspire your upcoming engagement.',
    linkUrl: 'https://www.marthastewartweddings.com/652216/valentines-day-proposal-tips-expert-approved',
  },
  {
    id: 50,
    imgSrc: 'https://gentux.imgix.net/1571241705_vr-logo-desktop_2x.png',
    imgAlt: 'Venue Report',
    title: 'eloping? here are 7 ways to incorporate your friends & family (without them being there)',
    content:
      'Eloping is one of the most whimsical and romantic ways to tie the knot and it produces some of the most stunning photography. But are you feeling stressed about not including all of your friends and family on your big day?',
    linkUrl:
      'https://www.venuereport.com/roundups/eloping-here-are-7-ways-to-incorporate-your-friends-and-family-without-them-being-there/entry/4/',
  },
  {
    id: 51,
    imgSrc: 'https://gentux.imgix.net/1571239746_Published-On-Junebug-Weddings-Badge-White.png',
    imgAlt: 'Junebug Weddings',
    title: 'rustic glam canal fulton, ohio backyard wedding',
    content:
      'This Ohio couple says &ldquo;I do,&rdquo; in the bride\u0027s family\u0027s lush backyard and then parties the night away in a huge tent filled with white linens, potted plants, and a rose-adorned cake. Featuring Generation Tux\u0027s Bright Blue Notch Lapel Suit.',
    linkUrl: 'https://junebugweddings.com/wedding-blog/rustic-glam-canal-fulton-ohio-backyard-wedding/',
  },
  {
    id: 52,
    imgSrc: 'https://gentux.imgix.net/1571239746_ps-dot-logo.png',
    imgAlt: 'Popsugar',
    title: 'color us coral! 22 ways to use 2019\u0027s hottest hue in your wedding',
    content:
      'Pantone\u0027s color of the year is the vibrant and playful living coral. Adding a splash of color to any big day, coral gives a fresh spin on wedding decor, accessories, and everything in between. Featuring Generation Tux\u0027s Navy Blue Notch Lapel Suit and Slate Blue Notch Lapel Suit.',
    linkUrl: 'https://www.popsugar.com/love/Living-Coral-Wedding-Ideas-45623597',
  },
  {
    id: 53,
    imgSrc: 'https://gentux.imgix.net/1571239746_ps-dot-logo.png',
    imgAlt: 'Popsugar',
    title: '17 unforgettable wedding trends to wow your guests in 2019',
    content:
      'With a new year comes new trends, and 2019 is already paving the way for even more beautiful and extraordinary weddings. Featuring Generation Tux\u0027s Black Notch Lapel Suit, Bright Blue Notch Lapel Suit, and Gray Notch Lapel Tuxedo.',
    linkUrl: 'https://www.popsugar.com/love/photo-gallery/45613272/image/45613282/Black-New-Black',
  },
  {
    id: 54,
    imgSrc: 'https://gentux.imgix.net/1571239746_ps-dot-logo.png',
    imgAlt: 'Popsugar',
    title: 'these ideas will bring the magic of movies into your wedding',
    content:
      'Here are the best tips and tricks from people in the wedding industry on how to add some movie magic into wedding ceremonies. Featuring Generation Tux\u0027s Black Peak Lapel Tuxedo.',
    linkUrl: 'https://www.popsugar.com/love/photo-gallery/45533030/image/45533032/Movie-Quote-Table-Names',
  },
  {
    id: 55,
    imgSrc: 'https://gentux.imgix.net/1571239745_perfete.png',
    imgAlt: 'Perfete',
    title: 'wedding inspo with pantone\u0027s color of the year living coral',
    content:
      'Living Coral will be a beautiful choice for our spring and summer brides. Here are some ideas on how to use this bright hue, from bridesmaid dresses to cakes and everything in between! Featuring Generation Tux\u0027s Slate Blue Notch Lapel Suit.',
    linkUrl: 'https://www.perfete.com/2018/12/wedding-inspo-with-pantones-color-of-the-year-living-coral.html',
  },
  {
    id: 56,
    imgSrc: 'https://gentux.imgix.net/1571239747_Screen%20Shot%202019-07-31%20at%2011.08.01%20AM.png',
    imgAlt: 'Southern Bride',
    title: 'stacie plummer & bryan pretty in pink',
    content:
      'This southern charm wedding was complete with large oak trees and a haven of Spanish moss. Featuring Generation Tux\u0027s Slate Blue Notch Lapel Suit.',
    linkUrl: 'https://www.southernbride.com/real_weddings/stacie-plummer-bryan-knapp/',
  },
  {
    id: 57,
    imgSrc: 'https://gentux.imgix.net/1571239748_woman%20getting%20married.png',
    imgAlt: 'Woman Getting Married',
    title: '10 things wedding experts want every bride to do',
    content:
      'Wedding planning is all about making decisions &mdash; but with so many options, especially for the big stuff, how are you supposed to pick and choose? Featuring Generation Tux\u0027s Mystic Blue Peak Lapel Suit.',
    linkUrl: 'https://www.womangettingmarried.com/wedding-planning-decisions/',
  },
  {
    id: 58,
    imgSrc: 'https://gentux.imgix.net/in-the-news-apracticalwedding.jpg',
    imgAlt: 'A Practical Wedding',
    title: 'wedding suit and tux rentals',
    content:
      'A Practical Wedding gives four reasons why renting your wedding suit or tuxedo online with Generation Tux is really the best way to go.',
    linkUrl: 'https://apracticalwedding.com/wedding-suit-tux-rentals-gentux/',
  },
  {
    id: 59,
    imgSrc: 'https://gentux.imgix.net/Clipboard%202017-16-05%20at%202.20.25%20PM.png',
    imgAlt: 'PR Newswire',
    title: 'say goodbye to the tape measure and hello to etailor',
    content:
      'Generation Tux, founded by George Zimmer, has announced that they have removed the tape measure from their fitting process using a new algorithm that accurately determines a person\u0027s measurements based on a series of questions.',
    linkUrl:
      'http://www.prnewswire.com/news-releases/generation-tux-is-revolutionizing-tuxedo--suit-rentals-via-machine-learning-with-etailor-tapeless-measuring-system-300455299.html',
  },
  {
    id: 60,
    imgSrc: 'https://gentux.imgix.net/Clipboard%202017-16-05%20at%202.20.25%20PM.png',
    imgAlt: 'PR Newswire',
    title: 'revolutionizing tuxedo & suit rentals with machine learning with etailor',
    content:
      'On top of the cutting-edge technology stack Generation Tux has already brought to the tuxedo and suit rental industry, eTailor will be the latest ground-breaking technology to hit the online tuxedo rental industry.',
    linkUrl:
      'http://www.prnewswire.com/news-releases/the-tape-stops-here-generation-tux-is-revolutionizing-tuxedo--suit-rentals-with-etailor-tapeless-measuring-system-300455298.html',
  },
  {
    id: 61,
    imgSrc: 'https://gentux.imgix.net/in-the-news-wedchick.jpg',
    imgAlt: 'Wedding Chicks',
    title: 'tailored suit & tux rentals',
    content:
      'Today is all about the GROOM and his GROOMSMEN! Prepare to breathe a sigh of relief, because we are going to show you how to coordinate all the men in your wedding with Generation Tux, a George Zimmer company.',
    linkUrl: 'http://www.weddingchicks.com/blog/tailored-suit-and-tux-rentals-l-14544-l-42.html',
  },
  {
    id: 62,
    imgSrc: 'https://gentux.imgix.net/Clipboard%202017-16-05%20at%202.31.58%20PM.png',
    imgAlt: 'WWD',
    title: 'george zimmer\u0027s company eliminating the tape measure',
    content: 'A new algorithm employs measurements from thousands of other men to predict a proper fit.',
    linkUrl: 'http://wwd.com/menswear-news/mens-clothing-furnishings/george-zimmers-company-eliminating-the-tape-measure-10884389/',
  },
  {
    id: 63,
    imgSrc: 'https://gentux.imgix.net/Clipboard%202017-16-05%20at%202.32.22%20PM.png',
    imgAlt: 'Apparatusmag',
    title: 'generation tux unveils tapeless measuring system',
    content:
      'Generation Tux is removing the tape measure from their fitting process. Instead of the traditional tape measure, they will now be incorporating a new algorithm that accurately determines a person\u0027s measurements based on a series of questions.',
    linkUrl: 'https://apparatusmag.com/2017/05/11/generation-tux-unveils-tapeless-measuring-system/',
  },
  {
    id: 64,
    imgSrc: 'https://gentux.imgix.net/in-the-news-ruffled.jpg',
    imgAlt: 'Ruffled',
    title: 'dare to be dapper with generation tux',
    content:
      'George Zimmer\u0027s Generation Tux is changing the game on how tux rentals work. With super 130\u0027s wool suits, they offer the finest of the fine and will have anyone donning them looking like a perfect TEN.',
    linkUrl: 'http://ruffledblog.com/dare-to-be-dapper-with-generation-tux/',
  },
  {
    id: 65,
    imgSrc: 'https://gentux.imgix.net/in-the-news-stylemepretty.jpg',
    imgAlt: 'Style Me Pretty',
    title: '5 ways to keep your groom + groomsmen happy and looking their best',
    content:
      'When it comes to dressing the bridal party, making sure the men in your life are happy is just as important as taking care of your besties.',
    linkUrl: 'http://www.stylemepretty.com/2017/03/08/5-ways-to-keep-your-groom-groomsmen-happy-and-looking-their-best/',
  },
  {
    id: 66,
    imgSrc: 'https://gentux.imgix.net/manregistry.png',
    imgAlt: 'The Man Registry',
    title: 'ask the george zimmer on men\u0027s wedding attire',
    content:
      'Starting with the elimination of multiple store visits, George\u0027s new venture &ndash; Generation Tux &ndash; is nothing short of a complete reinvention of the tuxedo rental experience.',
    linkUrl: 'https://themanregistry.com/groom-101/george-zimmer-mens-wedding-attire/',
  },
  {
    id: 67,
    imgSrc: 'https://gentux.imgix.net/in-the-news-paparazzi.jpg',
    imgAlt: 'Paparazzi Proposals',
    title: 'after your marriage generation tux',
    content:
      'You\u0027ve popped the question like a rockstar. And post marriage proposal, you\u0027re planning a wedding! It leaves little room to focus on one of the most important elements of the entire Your tux.',
    linkUrl: 'https://www.paparazzi-proposals.com/advice/after-your-marriage-proposal-generation-tux/',
  },
  {
    id: 68,
    imgSrc: 'https://gentux.imgix.net/in-the-news-apracticalwedding.jpg',
    imgAlt: 'A Practical Wedding',
    title: 'finally, online suit and tux rentals that are as hot as your partner',
    content:
      'One of the stereotypes I hate most about weddings is that men don\u0027t care about them. First of all, it\u0027s sexist. Also, I am pretty sure every APW staff member can put that myth to rest. But you know who hasn\u0027t gotten the memo that guys actually kind of care about their nuptials? The wedding industry.',
    linkUrl: 'http://apracticalwedding.com/2015/10/generation-tux-online-wedding-tux-rental/',
  },
  {
    id: 69,
    imgSrc: 'https://gentux.imgix.net/in-the-news-marketwatch.jpg',
    imgAlt: 'Market Watch',
    title: 'george zimmer launches generation tux at dreamforce annual conference in san francisco.',
    content:
      'George Zimmer launched Generation Tux today at the Dreamforce annual conference, transforming the tuxedo and suit rental market. The second George Zimmer Company to launch this year, Generation Tux is the first and only digital rental platform.',
    linkUrl:
      'http://www.marketwatch.com/story/george-zimmer-launches-generation-tux-at-dreamforce-annual-conference-in-san-francisco-revolutionizing-tuxedo-suit-rentals-with-innovative-online-platform-2015-09-15',
  },
  {
    id: 70,
    imgSrc: 'https://gentux.imgix.net/in-the-news-fastcompany.jpg',
    imgAlt: 'Fast Company',
    title: 'george zimmer launches online tux-rental service generation tux',
    content:
      'It\u0027s been a busy year for George Zimmer, the man best known for launching Men\u0027s Wearhouse in 1973. Earlier this year, Zimmer&mdash;who was ousted as the CEO and executive chairman of Men\u0027s Wearhouse in 2013&mdash;launched zTailors, a service that dispatches tailors to your home or office on demand',
    linkUrl: 'http://www.fastcompany.com/3051066/most-creative-people/george-zimmer-launches-online-tux-rental-service-generation-tux',
  },
  {
    id: 71,
    imgSrc: 'https://gentux.imgix.net/in-the-news-washingtonpost.jpg',
    imgAlt: 'The Washington Post',
    title: 'the new business from men\u0027s wearhouse founder george zimmer that wants to change how you rent tuxedos',
    content:
      'Just outside Louisville, former Men\u0027s Wearhouse chief executive George Zimmer has packed a 250,000-square-foot distribution center with 30,000 tuxedos, which, if his new business venture goes well, will soon be shipping out to grooms and promgoers across the country',
    linkUrl:
      'https://www.washingtonpost.com/news/business/wp/2015/09/14/the-new-business-from-mens-wearhouse-founder-george-zimmer-that-wants-to-change-how-you-rent-tuxedos/',
  },
  {
    id: 72,
    imgSrc: 'https://gentux.imgix.net/in-the-news-businessinsider.jpg',
    imgAlt: 'Business Insider',
    title: 'the \u0027i guarantee it guy\u0027 who got ousted from men\u0027s wearhouse is back',
    content:
      'George Zimmer, the ousted founder of the $2.3 billion men\u0027s clothing retailer Men\u0027s Wearhouse, has been seeking $40 million at a post-money valuation of $100 million for his new startup called Generation Tux, according to a pitch deck obtained by Business Insider.',
    linkUrl: 'http://www.businessinsider.com/mens-wearhouse-founder-george-zimmer-new-startup-worth-100-million-2015-9',
  },
  {
    id: 73,
    imgSrc: 'https://gentux.imgix.net/in-the-news-wbj.jpg',
    imgAlt: 'Washington Business Journal',
    title: '8 things: men\u0027s wearhouse founder bets you\u0027ll want to rent his tuxes',
    content:
      'It\u0027s (almost) exactly what you\u0027ve been waiting for: A website where you can rent a tuxedo — plus all the other fancy stuff that comes with it. And the website comes from George Zimmer, the ousted leader of Men\u0027s Wearhouse, which he founded.',
    linkUrl: 'http://www.bizjournals.com/washington/morning_call/2015/09/8-things-mens-wearhouse-founder-bets-youll-want-to.html',
  },
  {
    id: 74,
    imgSrc: 'https://gentux.imgix.net/in-the-news-bof.jpg',
    imgAlt: 'Business of Fashion',
    title: 'george zimmer takes on men\u0027s wearhouse with tuxedo start-up',
    content:
      'Last year, George Zimmer was ousted from Men\u0027s Wearhouse, the company he founded. His latest start-up, an online tailoring platform, is not doing so well. But now, Mr. Zimmer is sure he has a winner.',
    linkUrl: 'http://www.businessoffashion.com/daily-digest/2015/09/15#george-zimmer-takes-on-mens-wearhouse-with-tuxedo-start-up',
  },
  {
    id: 75,
    imgSrc: 'https://gentux.imgix.net/in-the-news-retaildive.jpg',
    imgAlt: 'Retail Dive',
    title: 'ousted men\u0027s wearhouse founder launches tux-rental start-up',
    content:
      'George Zimmer hasn\u0027t given up on zTailors, which is operational in several cities, but says it\u0027s still losing money. He expects Generation Tux to be a more immediate hit, though, telling the New York Times, &ldquo;I think it\u0027s the best idea I\u0027ve ever had.&quot;',
    linkUrl: 'http://www.retaildive.com/news/ousted-mens-wearhouse-founder-launches-tux-rental-start-up/405616/',
  },
  {
    id: 76,
    imgSrc: 'https://gentux.imgix.net/in-the-news-fortune.jpg',
    imgAlt: 'Fortune',
    title: 'men\u0027s warehouse creator launches tux company',
    content:
      'It\u0027s the second company started this year by George Zimmer, who was ousted by the Men\u0027s Wearhouse board in 2014. Generation Tux, a tuxedo rental site, will compete directly with Men\u0027s Wearhouse, which is the largest U.S. tuxedo rental service but doesn\u0027t rent them online.',
    linkUrl: 'http://fortune.com/2015/09/15/power-sheet-september-15-2015/',
  },
  {
    id: 77,
    imgSrc: 'https://gentux.imgix.net/in-the-news-cnnmoney.jpg',
    imgAlt: 'CNN Money',
    title: 'i guarantee it\u0027 zimmer launches another generation tux',
    content:
      'The startup is called Generation Tux. Zimmer is already familiar with the business of renting tuxedos, but now he\u0027s back and better than ever. Generation Tux is online-exclusive suit and tuxedo rental.',
    linkUrl: 'http://money.cnn.com/2015/09/15/news/companies/generation-tux-zimmer/index.html?iid=hp-stack-dom',
  },
  {
    id: 78,
    imgSrc: 'https://gentux.imgix.net/in-the-news-4pins.jpg',
    imgAlt: 'Four Pins',
    title: 'george zimmer aka the men\u0027s wearhouse guy is back again with another startup',
    content:
      'Ya man\u0027s is back again. If you hack your memory banks back to June, you\u0027ll recall that George Zimmer, the man who has guaranteed you\u0027ll like the way you look ever since he learned how to speak, started a company called zTailors, which matches tailors with potential customers...',
    linkUrl: 'http://fourpins.com/style/2015/09/george-zimmer-of-mens-wearhouse-fame-founds-tuxedo-rental-company',
  },
  {
    id: 79,
    imgSrc: 'https://gentux.imgix.net/in-the-news-bbj.jpg',
    imgAlt: 'Baltimore Business Journal',
    title: '8 things you need to know this morning',
    content: 'Ousted Men\u0027s Wearhouse founder George Zimmer will launch today a new website for tuxedo rentals.',
    linkUrl: 'http://www.bizjournals.com/baltimore/feature/8-things/2015/09/8-things-sept-15.html',
  },
  {
    id: 80,
    imgSrc: 'https://gentux.imgix.net/in-the-news-mr.jpg',
    imgAlt: 'Mr. Mag',
    title: 'george zimmer launches online tuxedo rental site',
    content:
      'It\u0027s tux redux for George Zimmer. The Men\u0027s Wearhouse founder, who was ousted from that company in 2013, unveiled his second company to launch this year, Generation Tux, an online tuxedo rental service, at the Dreamforce annual conference of business professionals in Oakland, Calif. today.',
    linkUrl: 'http://www.mr-mag.com/george-zimmer-launches-online-tuxedo-rental-site/',
  },
  {
    id: 81,
    imgSrc: 'https://gentux.imgix.net/in-the-news-cnbc.jpg',
    imgAlt: 'CNBC',
    title: 'george zimmer\u0027s new menswear business',
    content:
      'George Zimmer, founder of Men\u0027s Wearhouse, is back with two new companies, and calls his firing from the company he founded &quot;probably the greatest thing that ever happened to me.&quot;',
    linkUrl: 'http://video.cnbc.com/gallery/?video=3000422477',
  },
  {
    id: 82,
    imgSrc: 'https://gentux.imgix.net/in-the-news-bloomberg.jpg',
    imgAlt: 'Bloomberg Business',
    title: 'generation tux finds a fit for online formalwear',
    content:
      'George Zimmer, founder at Generation Tux, speaks with Pimm Fox about aggressive discounts in the men\u0027s clothing industry and his latest endeavor of online tuxedo and suit rentals. He speaks on &quot;Bloomberg Markets.&quot;',
    linkUrl: 'http://www.bloomberg.com/news/videos/2015-09-21/generation-tux-finds-a-fit-for-online-formalwear',
  },
  {
    id: 83,
    imgSrc: 'https://gentux.imgix.net/in-the-news-zimbio.jpg',
    imgAlt: 'Zimbio',
    title: 'george zimmer launches generation tux at dreamforce and announces first couple of 2016 contest',
    content:
      'George Zimmer, founder at Generation Tux, speaks with Pimm Fox about aggressive discounts in the men\u0027s clothing industry and his latest endeavor of online tuxedo and suit rentals. He speaks on &quot;Bloomberg Markets.&quot;',
    linkUrl: 'http://www.zimbio.com/pictures/pK2jEN1uemb/George+Zimmer+Launches+Generation+Tux+Dreamforce/ZT5pnmTd310',
  },
  {
    id: 84,
    imgSrc: 'https://gentux.imgix.net/in-the-news-trendhunter.jpg',
    imgAlt: 'Trend Hunter',
    title: 'george zimmer launched \u0027generation tux\u0027 to suit up men with just one click',
    content:
      'With Generation Y being more and more interested in non-committal, accessible and economical products and services, George Zimmer\u0027s \u0022Generation Tux\u0022 tuxedo rentals is a perfect fit.',
    linkUrl: 'http://www.trendhunter.com/trends/tuxedo-rentals',
  },
  {
    id: 85,
    imgSrc: 'https://gentux.imgix.net/in-the-news-psfk.jpg',
    imgAlt: 'PSFK',
    title: 'rebooting the black tie experience',
    content:
      'Generation Tux, created by Men\u0027s Wearhouse founder George Zimmer, is an online rental catalog of high-quality tuxedos and suits',
    linkUrl: 'http://www.psfk.com/2015/09/mens-wearhouse-ztailors-rebooting-black-tie-experience-generation-tux.html',
  },
  {
    id: 86,
    imgSrc: 'https://gentux.imgix.net/in-the-news-cnet.jpg',
    imgAlt: 'CNET',
    title: 'men\u0027s wearhouse founder creates second act online',
    content:
      'George Zimmer is back with an online suit rental service called Generation Tux. We talk to him about how he brought together high-tech and high-touch with his new startup.',
    linkUrl: 'http://www.cnet.com/videos/mens-wearhouse-founder-creates-second-act-online/',
  },
  {
    id: 87,
    imgSrc: 'https://gentux.imgix.net/in-the-news-rfid.jpg',
    imgAlt: 'RFID Journal',
    title: 'generation tux finds rfid well suited to its mission',
    content:
      'When George Zimmer, the founder and former CEO of Men\u0027s Wearhouse, looked to launch a new men\u0027s formal wear rental company this year, he wanted to create something that would set his company apart from its competitors.',
    linkUrl: 'http://www.rfidjournal.com/articles/view?13582/',
  },
  {
    id: 88,
    imgSrc: 'https://gentux.imgix.net/in-the-news-digiday.jpg',
    imgAlt: 'Digiday',
    title: 'tux rentals go digital with an assist from former men\u0027s wearhouse chief',
    content:
      'Men\u0027s Wearhouse founder George Zimmer\u0027s newest venture, Generation Tux, launched at the beginning of September to update the business of renting tuxedos for the digital consumer &mdash; no trips to the store necessary.',
    linkUrl:
      'http://digiday.com/brands/tux-rentals-go-digital-assist-former-mens-wearhouse-chief/?utm_source=Sailthru&utm_medium=email&utm_campaign=Daily%20-%20Good%202015-10-14&utm_term=Good%20Daily',
  },
  {
    id: 89,
    imgSrc: 'https://gentux.imgix.net/in-the-news-ruffled.jpg',
    imgAlt: 'Ruffled',
    title: 'generation tux + first couple 2016 contest!',
    content:
      'There is just something about a man in classy, well-tailored suit, isn\u0027t there? Generation Tux is a new online rental service which ensures that all the men in your wedding will look red carpet ready, without any of the hassle of a traditional suit or tux rental.',
    linkUrl: 'http://ruffledblog.com/generation-tux-first-couple-2016-contest/',
  },
  {
    id: 90,
    imgSrc: 'https://gentux.imgix.net/in-the-news-stylemepretty.jpg',
    imgAlt: 'Style Me Pretty',
    title: 'keep your groom + groomsmen happy with generation tux + a giveaway!',
    content:
      'Take a lineup of seriously modern tuxedos and suits and add in the ease and convenience of online shopping and the results are Generation Tux, a fab online boutique that is guaranteed to make your groom + groomsmen happy.',
    linkUrl: 'http://www.stylemepretty.com/2015/10/16/keep-your-groom-groomsmen-happy-with-generation-tux-a-giveaway/',
  },
];

class InTheNews extends React.Component {
  render() {
    return (
      <>
        <div className="bg-gray-lighter py-1">
          <Layout3x1
            className="m-section-hero"
            matchHeight={true}
            block1={
              <LinkPanel
                url="https://www.brides.com/exclusive-jordana-abraham-and-michael-marinelli-wedding-5211550"
                imgUrl="https://gentux.imgix.net/1639675055_BridesMichaelMarinelliAndWeddingPartyWearingGenerationTuxSuits.jpg?w=403&fit=crop&ar=1:1"
                imgAlt="Michael Marielli and wedding party wearing Generation Tux Suits"
                excerpt="Betches Co-Founder Jordana Abraham and Michael Marinelli's Boho Beach Wedding in Riviera Maya, Mexico"
                citation="Brides"
                trackerClass="tracker-link-news-hero-a-190314-163933"
                title="Exclusive: Betches Co-Founder Jordana Abraham and Michael Marinelli's Boho Beach Wedding in Riviera Maya, Mexico"
              />
            }
            block2={
              <LinkPanel
                url="https://equallywed.com/generation-tux-is-changing-the-game-of-ordering-suits-online/"
                imgUrl="https://gentux.imgix.net/1639675367_EquallyWedGenerationTuxChangingGameOrderingSuitsOnlineLGBTQWeddings.jpg?w=403&fit=crop&ar=1:1"
                imgAlt="Maria Palladino,co-founder and creative director of Equally Wed, wearing Generation Tux Tuxedo"
                excerpt="For many people like me, masculine-leaning and nonbinary, and many others within our community, sometimes shopping for a suit just sucks. Generation Tux is changing the game."
                citation="Equally Wed"
                trackerClass="tracker-link-news-hero-b-190314-163933"
                title="Generation Tux Is Changing The Game Of Ordering Suits Online"
              />
            }
            block3={
              <LinkPanel
                url="https://www.brides.com/exclusive-nicole-pellegrino-michael-freas-wedding-5200646"
                imgUrl="https://gentux.imgix.net/1639676510_BridesNicholePellegrinoandMichaelFreasModernWaterfrontWeddingInAnnapolisMaryland.jpg?w=403&fit=crop&ar=1:1"
                imgAlt="Nichole Pellegrino and Michael Freas wearing a Generation Tux suit walking along a doc arm in arm."
                excerpt="Nicole Pellegrino of Betches Brides and Michael Freas hosted a waterfront wedding in Annapolis, Maryland filled with modern and elegant details."
                citation="Brides"
                trackerClass="tracker-link-news-hero-c-190314-163933"
                title="Exclusive: Nicole Pellegrino and Michael Freas' Modern Waterfront Wedding in Annapolis, Maryland"
              />
            }
          >
            <h1 className="text-h1-display">In The News</h1>
            <Line />
            <p>
              For media inquiries:{' '}
              <a className="tracker-link-news-press_email-190314-163405" href="mailto:press@generationtux.com">
                press@generationtux.com
              </a>
            </p>
          </Layout3x1>
        </div>

        <div className="m-section container space-y-32">
          {newsItemsList.map((x) => (
            <React.Fragment key={x.id}>
              <div className="row">
                <div className="col-span-2 md:col-span-2 md:col-start-3 lg:col-span-2 lg:col-start-4">
                  <div className="mb-16 inline-block aspect-ratio-1by1">
                    <img src={x.imgSrc + '?fit=max&w=90'} alt={x.imgAlt} style={{ width: '90px', maxWidth: '100%' }} />
                  </div>
                </div>
                <div className="col-span-10 space-y-8 border-b-1 border-gray-light pb-32 md:col-span-7 lg:col-span-5">
                  <h3 className="text-h4">{x.title}</h3>

                  <p>{x.content}</p>

                  <p>
                    <a href={x.linkUrl} target="_blank" className="inline-flex items-center">
                      Read More <IconArrowRight className="ml-4 !text-gold-darker" />
                    </a>
                  </p>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>

        <div className="bg-gray-lighter py-1">
          <NextSteps
            ctaPageName="in_the_news"
            salesCallout1={<SalesCalloutSwatches ctaPageName="in_the_news" />}
            salesCallout2={<SalesCalloutInspiration ctaPageName="in_the_news" />}
          />
        </div>
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default InTheNews;
